<template>
    <div>
        <compFormEdit
            class="margin-top-15 margin-right-15"
            ref="supplierEditForm"
            :formdata="getBase"
            v-model="formData"
            :labelWidth="120"
        >
        </compFormEdit>
        <div class="text-right">
            <a
                v-if="this.typedata === 'distribution'"
                :href="url"
                target="_blank"
                style="margin-right: 85px"
                >{{ fileName }}</a
            >
            <vButton
                v-if="this.typedata === 'distribution'"
                theme="primary"
                @click="create"
                >{{
                    $t("boss.purchase.total", { defaultValue: "生成" })
                }}</vButton
            >
            <vButton v-else theme="primary" @click="submit">{{
                $t("boss.purchase.sure", { defaultValue: "确定" })
            }}</vButton>
            <vButton class="margin-left-10" @click="cancel">{{
                $t("boss.purchase.cancel", { defaultValue: "取消" })
            }}</vButton>
        </div>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
export default {
    props: ["activeid", "typedata"],
    data() {
        return {
            loading: false,
            formData: {},
            fileName: "",
            url: "",
        };
    },
    computed: {
        getBase() {
            if (this.typedata === "distribution") {
                return [
                    {
                        label: this.$t("boss.purchase.BOL_template", {
                            defaultValue: "BOL模板",
                        }),
                        key: "type",
                        tag: "vSelect",
                        span: 24,
                        options: [
                            { value: 0, label: "ESTES" },
                            { value: 1, label: "Southeastern" },
                            { value: 2, label: "YRC" },
                            { value: 3, label: "Holland Reddaway" },
                            { value: 4, label: "AACT" },
                            { value: 5, label: "CTII" },
                            { value: 6, label: "SAIA" },
                            { value: 7, label: "NPME" },
                            { value: 8, label: "ABFS" },
                        ],
                        on: {
                            "on-change": this.reset,
                        },
                    },
                ];
            } else {
                return [
                    {
                        label: this.$t("boss.purchase.contract_template", {
                            defaultValue: "合同模板",
                        }),
                        key: "type",
                        tag: "vSelect",
                        span: 24,
                        options: [
                            {
                                value: 1,
                                label: this.$t(
                                    "boss.purchase.marine_enterprises",
                                    {
                                        defaultValue: "海企",
                                    }
                                ),
                            },
                            {
                                value: 2,
                                label: this.$t(
                                    "boss.purchase.Huihong_Zhongjin",
                                    {
                                        defaultValue: "汇鸿中锦",
                                    }
                                ),
                            },
                            {
                                value: 3,
                                label: this.$t("boss.purchase.SAINTY", {
                                    defaultValue: "舜天",
                                }),
                            },
                            {
                                value: 4,
                                label: this.$t("boss.purchase.sumec", {
                                    defaultValue: "苏美达",
                                }),
                            },
                            {
                                value: 5,
                                label: this.$t("boss.purchase.PI_order", {
                                    defaultValue: "PI订单",
                                }),
                            },
                            {
                                value: 6,
                                label: this.$t("boss.purchase.samho", {
                                    defaultValue: "三昊",
                                }),
                            },
                            {
                                value: 7,
                                label: this.$t("boss.purchase.Yiwang", {
                                    defaultValue: "易网",
                                }),
                            },
                            {
                                value: 8,
                                label: this.$t("boss.purchase.Zhonggong", {
                                    defaultValue: "中工",
                                }),
                            },
                        ],
                    },
                ];
            }
        },
    },
    methods: {
        reset() {
            this.fileName = "";
            this.url = "";
        },
        async create() {
            const valid = await this.$refs.supplierEditForm.validate();
            if (!valid) return;
            this.loading = true;
            this.handleWebfs(
                process.env.VUE_APP_APIURL_BOSS +
                    "/api/v2/DeliverOrder/exportTemplate",
                { deliverOrderId: this.activeid, type: this.formData.type },
                { download: false }
            ).then(
                (res) => {
                    this.fileName = res.data.filename;
                    this.url = res.data.url;
                    this.loading = false;
                },
                (err) => {
                    this.loading = false;
                }
            );
        },
        async submit() {
            const valid = await this.$refs.supplierEditForm.validate();
            if (!valid) return;
            if (this.typedata === "distribution") {
                this.handleWebfs(
                    process.env.VUE_APP_APIURL_BOSS +
                        "/api/v2/DeliverOrder/exportTemplate",
                    { deliverOrderId: this.activeid, type: this.formData.type },
                    "download"
                );
            } else {
                this.handleWebfs(
                    process.env.VUE_APP_APIURL_BOSS +
                        "/api/v2/po/exportTemplate",
                    { id: this.activeid, type: this.formData.type },
                    "download"
                );
            }
        },
        cancel() {
            this.$emit("on-close");
        },
    },
};
</script>
